<template>
  <div style="height:100vh;">
    <div class="row h-100 mx-0">
      <div class="col-0 col-lg-6 d-none d-lg-flex px-0">
        <div class="h-100 w-100 sb-image-background" loading="lazy">
          <div
            class="h-100 d-flex align-items-center justify-content-center text-center tn-overlay"
          >
            <div>
              <h1 class="text-white font-weight-normal mb-4 hero-title">
                <strong>TN CYBERTECH BANK</strong>
              </h1>
<!--
              <h2 class="text-white">Everyday Banking For Everyday People</h2>
-->
            </div>
          </div>
        </div>
      </div>
      <div class=" col-12 col-lg-6 pr-0 pr-lg-1 d-flex align-items-center px-0">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import { useAuthStore } from '@/stores/auth';

export default {
  name: "LayoutPage",
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  mounted() {
    this.checkToken();
  },
  methods: {
    checkToken() {
      const isAuthenticated = this.authStore.isAuthenticated;
      const publicRoutes = ['DefaultMain', 'Default-Main', 'VerifyPhone', 'Register'];

      if (!isAuthenticated && !publicRoutes.includes(this.$route.name)) {
        this.$router.push("/omni");
      }
    }
  }
};
</script>
